export const OperacionCFFields = {
    CodOperacionCF: 'id',
    IdOperacionCF: 'idOperacionCF',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodUnidadNegocio: 'codUnidadNegocio',
    UnidadNegocio: 'descUnidadNegocio',
    CodSectorComercial: 'codSectorComercial',
    SectorComercial: 'descSectorComercial',
    FechaSolicitud: 'fechaSolicitud',
    
    RazonSocial: 'razonSocial',
    NumeroCuenta: 'numeroCuenta',
    CodOperacionCFTipo: 'codOperacionCFTipo',
    
    CodEstado: 'codEstado',
    DescEstado: 'descEstado',
    InformacionAdicionalEmpresa: 'informacionAdicionalEmpresa',
    
    SuccessFee: 'successFee',
    MontoMinimoSuccess: 'montoMinimoSuccess',
    CantMesesRetainer: 'cantMesesRetainer',
    MontoRetainerMensual: 'montoRetainerMensual',
    
    AcreditacionRetainerMensual: 'acreditacionRetainerMensual',
    Exclusividad: 'exclusividad',

    FechaAprobacion: 'fechaAprobacion',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    IdUsuarioUltMod: 'idUsuarioUltMod',
    NombreUsuarioUltMod: 'nombreUsuarioUltMod',
    ApellidoUsuarioUltMod: 'apellidoUsuarioUltMod',
    MailUsuarioUltMod: 'mailUsuarioUltMod',

    EstadoFinalizado: 'estadoFinalizado',
    IdMensaje: 'idMensaje',
    PermiteEditarOperacion: 'permiteEditarOperacion',
    PermiteEliminarOperacion: 'permiteEliminarOperacion',
} as const;